import { render } from "./policy.vue?vue&type=template&id=41513bec&scoped=true"
const script = {}

import "./policy.vue?vue&type=style&index=0&id=41513bec&lang=scss&scoped=true"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41513bec"]])

export default __exports__